import ViewSharedUtil from "../ViewSharedUtil.js";

class ViewSharedStateProcessor {
  constructor(keyName) {
    this.keyName = keyName;
    this.statesToInclude = [
      { name: "columns", statesToInclude: ["id", "width", "autoHeight"] },
      "selectedRecords",
      "zoomLevelOptions",
    ]
  }


  processStateRetrieval(prevProcessedState, viewManager, viewType, initialDefaultState) {
    const selectedView = viewManager.renderState.selectedView;
    const defaultView = viewManager.getDefaultViewByType(selectedView.viewType);
    const defaultViewStateForType = defaultView.viewState?.[viewType] || {};
    const processedState = {};

    this.statesToInclude.forEach((stateToInclude) => {
      if (typeof stateToInclude === "object") {
        if (defaultViewStateForType[stateToInclude.name]) {
          processedState[stateToInclude.name] = ViewSharedUtil.mergeNestedArrayTypeStateProcess(defaultViewStateForType, stateToInclude, initialDefaultState);
        } else {
          processedState[stateToInclude.name] = initialDefaultState[stateToInclude.name];
        }
      } else if (stateToInclude in defaultViewStateForType) {
        processedState[stateToInclude] = defaultViewStateForType[stateToInclude];
      }
    });

    return { ...prevProcessedState, ...processedState };
  }

  processStateMutation(prevProcessedState, stateToUpdate, initialDefaultState) {
    const processedState = {};

    this.statesToInclude.forEach((stateToInclude) => {
      if (typeof stateToInclude === "object" && stateToUpdate[stateToInclude.name]) {
        processedState[stateToInclude.name] = ViewSharedUtil.getNestedArrayTypeStateProcess(stateToUpdate, stateToInclude, initialDefaultState);
      } else if (stateToInclude in stateToUpdate) {
        processedState[stateToInclude] = stateToUpdate[stateToInclude]
      }
    });

    return { ...prevProcessedState, [this.keyName]: processedState };
  }
}

export default ViewSharedStateProcessor;
